var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-twitter-share"},[_c('a',{attrs:{"target":"_blank","href":_vm.createTwitterLink}},[_c('i',{staticClass:"fab fa-twitter"}),_vm._v(" "+_vm._s(_vm.buttonTitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }